import * as go from 'gojs';
import * as uuid from 'uuid';
import { getPointString } from '../../../../../utils/stringify-utils';
import { fontModelToGojsData } from '../../../utils/font-utils';
import { shadowModelToGojsData } from '../../../utils/shadow-utils';
import {
  LAYER_NAME_PROP,
  SHADOW_BLUR_PROP,
  SHADOW_COLOR_PROP,
  SHADOW_OFFSET_PROP,
  TEXT_FONT_PROP,
  Z_ORDER_PROP,
} from '../../common/config/common-prop-names';
import { startTextEditing } from '../../common/utils/start-text-editing';
import { TextNodeCreateProps } from '../models/text-node-create-props';
import { TextNode } from '../models/text-node.model';
import { bringToFront } from './../../../../../utils/bring-to-front-back/bring-to-front';

export const createTextNode = async (
  diagram: go.Diagram,
  {
    defaultFont,
    defaultTextAlignment,
    defaultTextColor,
    defaultTextHighlightColor,
    defaultShadow,
    defaultLocked,
    categoryName,
    location,
  }: TextNodeCreateProps,
) => {
  const gojsShadow = shadowModelToGojsData(defaultShadow, SHADOW_BLUR_PROP, SHADOW_COLOR_PROP, SHADOW_OFFSET_PROP);

  const gojsFont = fontModelToGojsData(defaultFont, TEXT_FONT_PROP);

  const key = uuid.v4();

  diagram.commit(async () => {
    diagram.model.addNodeData(
      new TextNode(
        key,
        categoryName,
        '',
        gojsFont[TEXT_FONT_PROP],
        defaultTextColor,
        defaultTextHighlightColor,
        defaultTextAlignment,
        defaultLocked,
        getPointString(location.x, location.y),
        gojsShadow[SHADOW_COLOR_PROP] as string,
        gojsShadow[SHADOW_OFFSET_PROP] as string,
        gojsShadow[SHADOW_BLUR_PROP] as number,
      ),
    );

    const node = diagram.findNodeForKey(key);
    if (node) {
      bringToFront(node, Z_ORDER_PROP, LAYER_NAME_PROP);
      await startTextEditing(diagram, node);
    }
  });

  return diagram.findNodeForKey(key);
};
